import React from "react";
import { useAppDispatch, useAppSelector, useDebounce } from "../../app/hooks";
import { selectUser } from "../../slices/user";
import {
  OneTimeVisitorArray,
  OneTimeVisitorData,
} from "../../api/models/one-time-visitor";
import api from "../../api";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import SearchInput from "../FormElements/SearchInput";
import { showError } from "../../utils/helpers";
import { selectLabels } from "../../slices/language";

export interface UserContactsToShow {
  name: string;
  phone: string;
  email: string;
}

interface UserContactsProps {
  setSelectedContact: (selectedContact: UserContactsToShow | null) => void;
}

const UserContacts = ({ setSelectedContact }: UserContactsProps) => {
  const user = useAppSelector(selectUser);
  const dispatch = useAppDispatch();
  const labels = useAppSelector(selectLabels);

  const [contacts, setContacts] = React.useState<UserContactsToShow[] | null>(
    null
  );
  const [contactName, setContactName] = React.useState<string>("");

  const debouncedContactName = useDebounce(contactName, 300);

  const getContacts = React.useCallback(
    async (debouncedText: string) => {
      if (user?.id) {
        let finalArray;
        try {
          const response = await api.getUserContacts(
            `${user?.id}`,
            1,
            20,
            debouncedText
          );
          if (response) {
            const fixedResponse: UserContactsToShow[] = response?.data.map(
              (item) => {
                return {
                  name: item?.name,
                  phone: item?.phone,
                  email: item?.email,
                };
              }
            );
            finalArray = fixedResponse;
            const visitorUsers = await api.getVisitorUsersByUnit(
              user?.unit?.id
            );
            if (visitorUsers && visitorUsers.length > 0) {
              const visitorFixedResponse: UserContactsToShow[] =
                visitorUsers.map((item) => {
                  return {
                    name: item?.name,
                    phone: item?.phone,
                    email: item?.email,
                  };
                });
              finalArray = [...finalArray, ...visitorFixedResponse];
            }
            setContacts(finalArray);
          }
        } catch (error: any) {
          console.error(error);
          const errorMessage = error?.response?.data?.error?.message;
          showError(
            dispatch,
            errorMessage ? errorMessage : labels.generic_error
          );
        }
      }
    },
    [dispatch, labels.generic_error, user?.id, user?.unit?.id]
  );

  React.useEffect(() => {
    getContacts(debouncedContactName);
  }, [debouncedContactName, getContacts]);

  return (
    <div>
      <SearchInput
        value={contactName}
        setValue={setContactName}
        size={"small"}
      />
      <TableContainer
        component={Paper}
        variant="outlined"
        style={{ marginTop: 16 }}
      >
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell align="center">Nombre</TableCell>
              <TableCell align="center">Teléfono</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {contacts &&
              contacts.length > 0 &&
              contacts.map((item, index) => (
                <TableRow
                  key={`${index}`}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  style={{ cursor: "pointer" }}
                  onClick={() => setSelectedContact(item)}
                >
                  <TableCell align="left">{item?.name}</TableCell>
                  <TableCell align="center">{item?.phone}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default UserContacts;
